import n8n from "../assets/n8n.png";
import dialogflow from "../assets/dialogflow.png";
import webhooks from "../assets/webhook.png";
import typebot from "../assets/typebot.jpg";
import flowbuilder from "../assets/flowbuilders.png";
import tavily from "../assets/tavily.svg";

export const INTEGRATION_CATALOG = [
  {
    id: "openai",
    group: "integrations",
    labelKey: "connections.addChannelModal.integrations.openai",
    planKey: "useOpenAi",
    route: "/prompts",
    visual: { brand: "openai", compactBrand: "openai" },
    descKey: "connections.addChannelModal.integrations.openaiDesc",
  },
  {
    id: "tavily",
    group: "integrations",
    labelKey: "connections.addChannelModal.integrations.tavily",
    planKey: "useOpenAi",
    route: "/connections",
    integrationType: "tavily",
    visual: { image: tavily },
    descKey: "connections.addChannelModal.integrations.tavilyDesc",
  },
  {
    id: "chat_agent",
    group: "integrations",
    labelKey: "connections.addChannelModal.integrations.chatAgent",
    planKey: "useOpenAi",
    route: "/connections",
    integrationType: "chat_agent",
    visual: { brand: "chat_agent", compactBrand: "chat_agent" },
    descKey: "connections.addChannelModal.integrations.chatAgentDesc",
  },
  {
    id: "dialogflow",
    group: "integrations",
    labelKey: "connections.addChannelModal.integrations.dialogflow",
    planKey: "useIntegrations",
    route: "/queue-integration",
    integrationType: "dialogflow",
    visual: { image: dialogflow, compactBrand: "dialogflow" },
  },
  {
    id: "n8n",
    group: "integrations",
    labelKey: "connections.addChannelModal.integrations.n8n",
    planKey: "useIntegrations",
    route: "/queue-integration",
    integrationType: "n8n",
    visual: { image: n8n, compactBrand: "n8n" },
  },
  {
    id: "webhook",
    group: "integrations",
    labelKey: "connections.addChannelModal.integrations.webhook",
    planKey: "useIntegrations",
    route: "/queue-integration",
    integrationType: "webhook",
    visual: { image: webhooks, compactBrand: "webhook" },
  },
  {
    id: "typebot",
    group: "integrations",
    labelKey: "connections.addChannelModal.integrations.typebot",
    planKey: "useIntegrations",
    route: "/queue-integration",
    integrationType: "typebot",
    visual: { image: typebot, compactBrand: "typebot" },
  },
  {
    id: "flowbuilder",
    group: "integrations",
    labelKey: "connections.addChannelModal.integrations.flowbuilder",
    planKey: "useIntegrations",
    route: "/queue-integration",
    integrationType: "flowbuilder",
    visual: { image: flowbuilder, compactBrand: "flowbuilder" },
  },
];

export const isIntegrationUsable = (integration, planConfig) => {
  if (!planConfig?.plan || !integration.planKey) return false;
  const value = planConfig.plan[integration.planKey];
  if (value === false || value === 0 || value === "0" || value === "false") {
    return false;
  }
  return true;
};

export const hasAnyIntegrationAccess = (planConfig) =>
  INTEGRATION_CATALOG.some((item) => isIntegrationUsable(item, planConfig));

export const getCatalogByType = (type) =>
  INTEGRATION_CATALOG.find(
    (item) => item.integrationType === type || item.id === type
  );

export const getIntegrationTypeLabel = (type) => {
  const item = getCatalogByType(type);
  return item?.labelKey || `connections.addChannelModal.integrations.${type}`;
};
